export const DOMAIN_NOT_RESOLVING_ERROR_TYPE = 'DOMAIN_NOT_RESOLVING';
export const VARIATION_CATEGORY_NOT_SYNCED_ERROR_TYPE = 'VARIATION_CATEGORY_NOT_SYNCED';